export default __webpack_public_path__ + "static/8_EUROSTYL_EKSPRESJA-664be6ea81294c5a54e93a3bc4bf6818.png";